<template>
  <div class="md-layout">
    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100 page-container-side text-right">
          <div><h3>{{$t('your-details')}}</h3></div>
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <div class="page-container-section">
            <form novalidate @submit.prevent="submit" autocomplete="off">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('firstName')">
                    <label for="first-name">{{$t('first-name')}}</label>
                    <md-input name="first-name" id="first-name" v-model="form.firstName" :disabled="sending"/>
                    <span class="md-error" v-if="!$v.form.firstName.required">{{$t('enter-first-name')}}</span>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('lastName')">
                    <label for="last-name">{{$t('last-name')}}</label>
                    <md-input name="last-name" id="last-name" v-model="form.lastName" :disabled="sending"/>
                    <span class="md-error" v-if="!$v.form.lastName.required">{{$t('enter-last-name')}}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('email')">
                    <label for="email">{{$t('email-address')}}</label>
                    <md-input type="email" name="email" id="email" v-model="form.email" :disabled="sending" v-on:input="emailChange" />
                    <!-- <span class="md-helper-text">For enquiries relating to purchases made through Creative Store, please use the same email address used to make the online purchase.</span> -->
                    <span class="md-error" v-if="!$v.form.email.required">{{$t('enter-email')}}</span>
                    <span class="md-error" v-else-if="!$v.form.email.email">{{$t('enter-valid-email')}}</span>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-50 md-small-size-100" v-show="showPid">
                  <md-field :class="getValidationClass('pid')">
                    <label for="pid">{{$t('pid')}}</label>
                    <md-input type="text" name="pid" id="pid" v-model="form.pid" :disabled="sending" />
                    <span class="md-error" v-show="!$v.form.pid.isUnique">{{$t('enter-pid')}}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="showLoginMsg">
                <div class="md-layout-item md-size-50 md-small-size-100" style="margin-top:-40px;">
                  <p>
                    <span v-html="$t('email_registered.text1', {email: form.email })"></span>
                    <a href="javascript:;" v-on:click="openLogin()">{{$t('email_registered.link')}}</a>
                    <span v-html="$t('email_registered.text2')"></span>
                  </p>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('country')">
                    <label for="country">{{$t('country-region')}}</label>
                    <md-select v-model="form.country" id="country" name="country" md-dense :disabled="sending">
                      <md-option :value="item.id" v-for="item in countries" v-bind:key="item.id">{{item.name}}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.language.required">{{$t('select-country')}}</span>
                  </md-field>
                  <div v-html="$t(`shipping-country-notice-${store}`)">
                  </div>
                </div>

                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('language')">
                    <label for="langauge">{{$t('preferred-language')}}</label>
                    <md-select v-model="form.language" id="language" name="language" md-dense :disabled="sending">
                      <md-option :value="item.id" v-for="item in languageReplies" v-bind:key="item.id">{{item.name}}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.language.required">{{$t('select-language')}}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout" v-if="step==1">
                <div class="md-layout-item text-right">
                  <md-button type="submit" class="md-raised md-accent" :disabled="sending">
                    {{$t('next')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="sending"></md-progress-spinner>
                  </md-button>
                </div>
              </div>
              <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
            </form>
          </div>
        </div>
      </div>
      <full-page-loading :show="fullPageLoading" :error="showErrorMsg" />
    </div>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email
  } from 'vuelidate/lib/validators'
  import Auth from '../mixins/auth'
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import { languageCode, storeUrl, getStoreCodeByUrl } from '../mixins/store'
  import { apiServer, publicPath } from '../config'
  import FullPageLoading from '../components/FullPageLoading'

  export default {
    name: 'YourDetails',
    mixins: [validationMixin],
    components: {
      FullPageLoading
    },
    data: () => ({
      form: {
        firstName: null,
        lastName: null,
        language: 1,
        country: 0,
        email: null,
        pid: ''
      },
      showPid: false,
      isRequiredPID: false,
      sending: false,
      loading: false,
      countries: [],
      languageReplies: [],
      showErrorMsg: false,
      showLoginMsg: false,
      fullPageLoading: true
    }),
    watch: {
     'form.country' : function(v) {
        this.countryChange(v)
      }
    },
    computed: {
      ...mapState({
        store: 'store',
        country: 'country',
        step: 'step'
      })
    },
    async created() {
      this.showPageLoading()
      const cookie_country = this.$cookies.get('rma_country')
      if (cookie_country) this.changeCountry(cookie_country)
      const r = await this.$http.request({ url: `${apiServer}/api/your-details?store=${this.store}`, method: 'get', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch((e) => {
        // unauthorized, token incorrect or token is empty
        if(e && e.response && e.response.status == 401) {
          // empty token of localStorage
          Auth.updateToken('')
          this.changeStep(1)
          // refersh page                                                                                                                                                             n
          window.location.reload()
        }
        this.hidePageLoading()
        this.changeStep(1)
        this.showErrorMsg = true
      })
      if (r && r.status == 200) {

        this.fullPageLoading = false
        if (r.data && r.data.clearCookies) {
          // clear cookie if user logout
          this.clearCookie()
        }
        if (r.data && r.data.token && r.data.token.length > 0) {
          // new token - update local token when api return new token
          Auth.updateToken(r.data.token)
          // refersh page
          location.reload()
        }
        if (r.data) {
          this.form.email = r.data.email
          this.form.firstName = r.data.firstName
          this.form.lastName = r.data.lastName
          this.form.pid = r.data.pid == null ? '' : r.data.pid
          this.form.language = r.data.languageReply
          this.countries = r.data.countryList
          this.languageReplies = r.data.languageReplyList
          // get customer detail from cookies for old Contact Us
          this.loadDetailFromCookie()
          if(this.country) this.form.country = parseInt(this.country)
          else this.form.country = r.data.country

          this.showPid = parseInt(this.country) == 886 ? true : false;

        }
        this.hidePageLoading()
        this.changeStep(localStorage.rma_step && localStorage.rma_step > 0 ? localStorage.rma_step : 1)
      }
      else {
        this.hidePageLoading()
        this.showErrorMsg = true
      }
      this.autoSubmit()
    },
    validations: {
      form: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        language: {
          required
        },
        email: {
          required,
          email
        },
        country: {
          required
        },
        pid: {
          isUnique(value) {
            if (this.country === types.COUNTRY.TAIWAN) {
                return (value === '' || value.length < 5 ) ? false : true;
            }
            else {
              this.form.pid = '-'
              return true
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE,
        changeStep: types.CHANGE_STEP,
        showPageLoading: types.SHOW_LOADING,
        hidePageLoading: types.HIDE_LOADING,
        showLogin: types.SHOW_DROP_MENU,
        setupLoginForm: types.CHANGE_DROP_MENU,
        changeCountry: types.CHANGE_COUNTRY
      }),
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm() {},
      updateDetail() {
        this.sending = true
        this.showPageLoading()
        this.$http.post(`${apiServer}/api/your-details`, {
          store: this.store,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          country: this.form.country,
          pid: this.form.pid,
          languageReply: this.form.language
        }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.sending = false
          this.hidePageLoading()
          if (data && data.token && data.token.length > 0) Auth.updateToken(data.token)
          if (data.status == 'success') this.changeStep(2)
          else this.showErrorMsg = true
        }).catch(() => {
          this.sending = false
          this.showErrorMsg = true
          this.hidePageLoading()
        })
      },
      autoSubmit() {
        if (this.step == 1 && this.store == 'tw' && this.form.pid.length <= 0) {
          this.sending = false
        }
        else if (this.step == 1 &&
        this.form.firstName && this.form.firstName.length > 0
        && this.form.lastName && this.form.lastName.length > 0
        && this.form.email
        && this.form.email.length > 0) {
          this.sending = true
          this.updateDetail()
        }
      },
      emailChange() {
        this.changeStep(1)
        if (!this.$v.$invalid) {
          this.$http.post(`${apiServer}/api/your-details/email-status`, { email: this.form.email, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } })
          .then(({data}) => {
            if (data && data.status == 'member' && !data.loggedIn)
              this.showLoginMsg = true
            if (data && data.token && data.token.length > 0) Auth.updateToken(data.token)
          })
        }
        else {
          this.showLoginMsg = false
        }
      },
      countryChange(v) {
        if (v) {
          const countrySelect = parseInt(v)
          if (countrySelect > 0) {
            const storeItem = this.countries.find(a => { return a.id == countrySelect })
            // window.console.log(countrySelect)
            // window.console.log(storeItem)
            if (storeItem && storeItem.id > 0) {
              if (this.country != countrySelect)
                this.changeStep(1)
              this.changeStore(storeItem.store)
              this.changeCountry(storeItem.id)

              this.showPid = parseInt(this.country) == 886 ? true : false;

              this.$cookies.set('rma_country', storeItem.id, '1h', publicPath, location.href.indexOf('localhost')>=0?'':'creative.com')
              const storeCode = getStoreCodeByUrl(location.href)
              //window.console.log(this.country, this.store, storeCode)
              if (storeCode && storeCode.length > 0 && storeCode != storeItem.store)
                  location.href = `${storeUrl(storeItem.store)}${publicPath}/`
              this.$i18n.locale = languageCode[storeItem.store]
            }
          }
        }
      },
      submit() {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.updateDetail()
        }
        else {
          this.showLoginMsg = false
        }
      },
      openLogin() {
        this.setupLoginForm({ type: 'iframe', url: `${storeUrl(this.store)}/account/signup?layout=no&source=topmenu&e=${this.form.email}`, height: 'auto' })
        this.showLogin()
      },
      loadDetailFromCookie() {
        const firstName = this.$cookies.get('firstname')
        if(
          (!this.form.firstName || this.form.firstName.length == 0) && firstName && firstName.length > 0
          )
          this.form.firstName = firstName
        const lastName = this.$cookies.get('lastname')
        if(
          (!this.form.lastName || this.form.lastName.length == 0) && lastName && lastName.length > 0
          )
          this.form.lastName = lastName
        const email = this.$cookies.get('emailaddress')
        if(
          (!this.form.email || this.form.email.length == 0) && email && email.length > 0
          )
          this.form.email = decodeURIComponent(email)
      },
      clearCookie() {
        this.$cookies.remove('firstname')
        this.$cookies.remove('lastname')
        this.$cookies.remove('emailaddress')
        this.$cookies.remove('rma_country')
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";
</style>